module.exports = __webpack_public_path__ + "static/header-83eb434e13270a70bd668de2a0b4d4c3.jpg";